import React from 'react';

function About() {
  return (
    <div className="about-container">
      <div className="container py-5">
        <h1>About Zerodha</h1>
        <div className="row mt-4">
          <div className="col-md-8">
            <p className="lead">
              Zerodha is India's largest stock broker by active retail clients. The name Zerodha is derived from the Sanskrit word "Zerodha," which means "free from barriers."
            </p>
            <p>
              Founded in 2010, Zerodha revolutionized zero-cost equity investments and flat-fee broking in India. Today, we are India's largest retail stockbroker by active clients.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;